var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Severity Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 0.517578C2.68629 0.517578 0 3.20387 0 6.51758C0 9.83129 2.68629 12.5176 6 12.5176C9.31371 12.5176 12 9.83129 12 6.51758C12 4.92628 11.3679 3.40016 10.2426 2.27494C9.11742 1.14972 7.5913 0.517578 6 0.517578ZM4.35355 4.18942C4.15829 3.99415 3.84171 3.99415 3.64645 4.18942C3.45118 4.38468 3.45118 4.70126 3.64645 4.89652L5.29289 6.54297L3.64645 8.18942C3.45118 8.38468 3.45118 8.70126 3.64645 8.89652C3.84171 9.09178 4.15829 9.09178 4.35355 8.89652L6 7.25008L7.64645 8.89652C7.84171 9.09178 8.15829 9.09178 8.35355 8.89652C8.54882 8.70126 8.54882 8.38468 8.35355 8.18942L6.70711 6.54297L8.35355 4.89652C8.54881 4.70126 8.54881 4.38468 8.35355 4.18942C8.15829 3.99415 7.84171 3.99415 7.64645 4.18942L6 5.83586L4.35355 4.18942Z",
    fill: "#E73D3D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.87e68e405de7905a26adeb4f48d73f61.svg";
export { ForwardRef as ReactComponent };